@import './ui-cms-tab';

ui-cms-tab {
  sd-tab-panel {
    padding: 0 1.5rem;
  }
}
